// This file is in public/ folder, and included in script tag in public/index.html
// It is old, and does not play nicely with webpack, so it is not included in the build
export const dymo = window.dymo;
